var Spirit = {
    handle: "spirit",
    
    abilities: {
        healing_prayer: {
            handle: "healing_prayer",
            unlockLevel: 1 
        },
        
        mystic_focus: {
            handle: "mystic_focus",
            unlockLevel: 5 
        },
        
        iron_will: {
            handle: "iron_will",
            unlockLevel: 13,
            passive: true
        },
        
        send_mana: {
            handle: "send_mana",
            unlockLevel: 21 
        },
        
        bless: {
            handle: "bless",
            unlockLevel: 29 
        },

        sanctuary: {
            handle: "sanctuary",
            unlockLevel: 37 
        },

        holy_force: {
            handle: "holy_force",
            unlockLevel: 45 
        }
    }
};
module.exports = Spirit;